const CloseBigIcon = ({ color = 'currentColor' }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.4937 0.506282C17.8354 0.84799 17.8354 1.40201 17.4937 1.74372L1.74372 17.4937C1.40201 17.8354 0.84799 17.8354 0.506282 17.4937C0.164573 17.152 0.164573 16.598 0.506282 16.2563L16.2563 0.506282C16.598 0.164573 17.152 0.164573 17.4937 0.506282Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.506282 0.506282C0.84799 0.164573 1.40201 0.164573 1.74372 0.506282L17.4937 16.2563C17.8354 16.598 17.8354 17.152 17.4937 17.4937C17.152 17.8354 16.598 17.8354 16.2563 17.4937L0.506282 1.74372C0.164573 1.40201 0.164573 0.84799 0.506282 0.506282Z"
        fill={color}
      />
    </svg>
  );
};

export default CloseBigIcon;
